import { colors } from '../theme';

const ENV_LABELS: Record<string, string> = {
  development: 'Development',
  staging: 'Staging',
  production: 'Production',
  preview: 'Preview',
};

export function EnvironmentPill({ environment }: { environment: string }) {
  const label = ENV_LABELS[environment] ?? environment;
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 999,
        background: colors.pillBg,
        color: colors.pillText,
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      {label}
    </span>
  );
}
